"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiMyProfile {
    static getIntroEmployee(token) {
        let url = `/profile/intro/employee`;
        return Client_1.default.httpGet(url, token);
    }
    static getIntroClient(token) {
        let url = `/profile/intro/client`;
        return Client_1.default.httpGet(url, token);
    }
    static getIntroProspect(token) {
        let url = `/profile/intro/prospect`;
        return Client_1.default.httpGet(url, token);
    }
    static getAdminDetails(token) {
        let url = `/profile/adminDetails`;
        return Client_1.default.httpGet(url, token);
    }
    static getClientNames(token) {
        let url = `/profile/clientNames`;
        return Client_1.default.httpGet(url, token);
    }
    static getClientsWithEmployees(token) {
        let url = `/profile/clients/employees`;
        return Client_1.default.httpGet(url, token);
    }
    static getPrimaryClient(token) {
        let url = `/profile/primaryClient`;
        return Client_1.default.httpGet(url, token);
    }
    static setPrimaryClient(token, body) {
        let url = `/profile/primaryClient`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getPermissions(token, employeeId) {
        let url = `/profile/permissions?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getPersonalInfo(token, employeeId) {
        if (!employeeId)
            employeeId = '';
        let url = `/profile/personalInfo?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmploymentInfo(token, employeeId) {
        if (!employeeId)
            employeeId = '';
        let url = `/profile/employmentInfo?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmergencyContacts(token) {
        let url = `/profile/emergencyContacts`;
        return Client_1.default.httpGet(url, token);
    }
    static updateEmergencyContact(token, body) {
        let url = `/profile/emergencyContacts`;
        return Client_1.default.httpPost(url, token, body);
    }
    static deleteEmergencyContact(token, body) {
        let url = `/profile/emergencyContacts`;
        return Client_1.default.httpDelete(url, token, body);
    }
    static updatePermissions(token, body) {
        let url = `/profile/permissions`;
        return Client_1.default.httpPost(url, token, body);
    }
    static updatePersonalInfo(token, body) {
        let url = `/profile/update`;
        return Client_1.default.httpPost(url, token, body);
    }
    static updateUsername(token, body) {
        let url = `/profile/updateusername`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getDemoLoginToken(token) {
        let url = `/profile/demo/token`;
        return Client_1.default.httpGet(url, token);
    }
    static verifyImpersonationToken(token, body) {
        let url = `/profile/impersonate/verify`;
        return Client_1.default.httpPost(url, token, body);
    }
    static endEmployeeImpersonation(token) {
        let url = `/profile/impersonate/end`;
        return Client_1.default.httpPost(url, token, {});
    }
    static updateDeviceToken(token, body) {
        let url = `/profile/device`;
        return Client_1.default.httpPost(url, token, body);
    }
    static deleteDeviceToken(token, body) {
        let url = `/profile/device`;
        return Client_1.default.httpDelete(url, token, body);
    }
    static disableDevice(token, body) {
        let url = `/profile/device/disable`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getDevices(token) {
        let url = `/profile/device`;
        return Client_1.default.httpGet(url, token);
    }
    static getNotificationSettings(token, deviceName) {
        let url = `/profile/notifications/settings?deviceName=${deviceName}`;
        return Client_1.default.httpGet(url, token);
    }
    static setNotificationSettings(token, body) {
        let url = `/profile/notifications/settings`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getSecurityQuestions(token) {
        let url = `/profile/security/questions`;
        return Client_1.default.httpGet(url, token);
    }
    static setSecurityQuestions(token, body) {
        let url = `/profile/security/questions`;
        return Client_1.default.httpPost(url, token, body);
    }
    static sendPwdEmailConfirmation(token) {
        let url = `/profile/password/email-confirmation`;
        return Client_1.default.httpPost(url, token, {});
    }
    static clearPrimaryClient(token) {
        let url = `/profile/primaryClient`;
        return Client_1.default.httpDelete(url, token, {});
    }
}
exports.default = ApiMyProfile;
